export default "__VITE_PUBLIC_ASSET__1f8f79ae__"